import {Divider} from 'antd';

import * as styles from './page-card-divider.scss';

export function MainPageCardDivider(): JSX.Element {
    return <Divider className={styles.main_page_card_divider} />;
}
